import cls from 'classnames'

type OnboardingProgressBarProps = {
	readonly className?: string
	readonly progressPercent: number
}

export const OnboardingProgressBar = ({
	className,
	progressPercent,
}: OnboardingProgressBarProps) => (
	<div className={cls(className, 'w-full bg-gray-90 h-3')}>
		<span
			className={cls('bg-teal h-full block transition-all duration-500 ease-in-out', {
				'rounded-r-lg': progressPercent !== 100,
			})}
			style={{ width: `${progressPercent}%` }}
		/>
	</div>
)
